import qs from 'qs';
import { useMutation } from 'react-query';
import { network } from 'services/network';

const mutationFn = ({ id }: QueryParams) => {
    const querystring = qs.stringify({ id }, { addQueryPrefix: true, skipNulls: true });
    const url = `api/bo/management/deleteContract${querystring}`;
    return network.post(url).then((response) => response.data);
};
export const useMutationDeleteSubProgram = () => {
    return useMutation<string, QueryError, QueryParams>({
        mutationFn: (params) => mutationFn(params),
    });
};

interface QueryParams {
    id?: number;
}
